export const Language = [
    { code: 'sw', name: 'Swahili'},
    { code: 'en', name: 'English'}
];

export const Translator = {
    "sw": {
        "language":"swahili",
        "yes_option":"Ndiyo",
        "no_option":"Hapana",
        "male_sex":"Kiume",
        "female_sex":"Kike",
        "male_subject_pronoun":"yeye",
        "male_personal_pronoun":"naye",
        "male_possessive_pronoun":"yake",
        "female_subject_pronoun":"yeye",
        "female_personal_pronoun":"naye",
        "female_possessive_pronoun":"yake",
        "passwords_unmatch":"Maneno siri hayakufanana",
        "incorrect_old_password":"Neno siri la zamani limekosewa",
        "password_change_success":"Umefanikiwa kubadili neno siri",
        "login_title":"SMART GROWTH DIARY",
        "login_button":"LOG IN","page":"ingia",
        "login_username_label":"Ingiza Jina la mtumiaji",
        "login_password_label":"Ingiza Neno siri",
        "forgot_password_button":"Umesahau neno siri",
        "login_error":"Taarifa ulizo ingiza sio sahihi",
        "dashboard_title":"SMARTGROWTHDIARY",
        "dashboard_metrics_button":"VIPIMO",
        "dashboard_growth_chart_button":"CHATI YA UKUAJI",
        "dashboard_nutritional_advice_button":"USHAURI ULIOPITA",
        "dashboard_feeding_advice_button":"LISHE",
        "dashboard_contact_us_button":"WASILIANA NASI",
        "dashboard_faqs_button":"MASWALI NA MAJIBU",
        "dashboard_home_button":"Dashibodi",
        "dashboard_chart_button":"Chati",
        "dashboard_contact_button":"Mawasiliano",
        "dashboard_advice_button":"Ushauri",
        "dashboard_short_faqs_button":"Maswali",
        "dashboard_child_name_label":"JINA",
        "dashboard_child_age_label":"UMRI",
        "dashboard_child_dob_label":"TAREHE YA KUZALIWA",
        "dashboard_child_sex_label":"JINSIA",
        "dashboard_child_residence_label":"MAKAZI",
        "dashboard_child_twin_sibling_status_label":"PACHA?",
        "dashboard_change_password_label":"BADILI NENO SIRI",
        "dashboard_logout_label":"TOKA",
        "metrics_weight_label":"Ingiza Uzito",
        "metrics_height_label":"Ingiza Urefu",
        "metrics_submit_button":"KOKOTOA",
        "metrics_form_title":"Ingiza taarifa hapo chini kujua maendeleo ya",
        "metrics_success_a":"Hongera",
        "metrics_success_ax":"Uzito wa",
        "metrics_success_b":"anakua vizuri",
        "metrics_success_bx":"bado ni mzuri.<br/><font color='red'>Lakini uzito umepungua ukilinganishwa na ule uliorekodiwa mara ya mwisho<br/>Kama anaumwa tafadhali muone daktari</font>",
        "metrics_weight_error":"Uzito wa mtoto hautakiwi kuzidi kilo 30",
        "metrics_height_error":"Hakikisha urefu haupo chini ya 45 na viwango vya desimali vya urefu ni 5 au 0",
        "metrics_age_error_a":"haiwezekani tena kuingiza taarifa za vipimo kwasababu",
        "metrics_age_error_b":"umri umezidi miezi 24",
        "metrics_warning_title":"Tumekuta matatizo yafuatayo kwa",
        "metrics_warning_footer":"Bonyeza ENDELEA ili kupata ushauri wa lishe",
        "metrics_warning_save_button":"TUNZA",
        "metrics_warning_next_button":"ENDELEA",
        "metrics_warning_cancel_button":"GHAIRI",
        "metrics_warning_WA_label":"W/A",
        "metrics_warning_HA_label":"H/A",
        "metrics_warning_WH_label":"W/H",
        "metrics_warning_is_sick_question_a":"je",
        "metrics_warning_is_sick_question_b":"anaumwa",
        "metrics_warning_empty_option":"Ugonjwa gani?",
        "metrics_warning_illness_warning_a":"Kutokana na ugonjwa wa",
        "metrics_warning_illness_warning_b":"tafadhali muone Daktari mara moja.Na kama umeshamuona Daktari tafadhali fuata ushauri uliopewa.",
        "metrics_warning_illness_warning_instruction_a":"Bonyeza ENDELEA kupata hali ya lishe ya",
        "metrics_warning_illness_warning_instruction_b":"au bonyeza GHAIRI kurudi kwenye dashibodi",
        "metrics_warning_severe_under_WA_status":"Uzito Mdogo mkali",
        "metrics_warning_moderate_under_WA_status":"Uzito Mdogo Wastani",
        "metrics_warning_mild_under_WA_status":"Uzito Mdogo kiasi",
        "metrics_warning_severe_over_WA_status":"Uzito Mkubwa Sana",
        "metrics_warning_moderate_over_WA_status":"Uzito Mkubwa ",
        "metrics_warning_mild_over_WA_status":"Uzito Mkubwa Kiasi",
        "metrics_warning_severe_under_HA_status":"Udumavu Mkali",
        "metrics_warning_moderate_under_HA_status":"Udumavu Wastani",
        "metrics_warning_mild_under_HA_status":"Udumavu Mdogo Kiasi",
        "metrics_warning_severe_over_HA_status":"Huenda Urefu Sio Kawaida",
        "metrics_warning_moderate_over_HA_status":"Urefu wa Kawaida",
        "metrics_warning_mild_over_HA_status":"Urefu wa Kawaida",
        "metrics_warning_severe_under_WH_status":"Unyafuzi Mkali",
        "metrics_warning_moderate_under_WH_status":"Unyafuzi Wastani",
        "metrics_warning_mild_under_WH_status":"Unyafuzi Kiasi",
        "metrics_warning_severe_over_WH_status":"Uzito Mkubwa Sana",
        "metrics_warning_moderate_over_WH_status":"Uzito Uliozidi",
        "metrics_warning_mild_over_WH_status":"Uzito Uliozidi",
        "feeding_practice_instruction_a":"Bonyeza",
        "feeding_practice_instruction_b":"kujaza taarifa za unyonyeshaji pamoja na ulishaji",
        "feeding_practice_next_button":"ENDELEA",
        "feeding_practice_submit_button":"Wasilisha",
        "feeding_practice_breastfeed_label":"JAZA TAARIFA ZA UNYONYESHAJI",
        "feeding_practice_mealfeed_label":"JAZA ULISHAJI WA CHAKULA NDANI YA SAA 24",
        "feeding_practice_breastfeed_option_placeholder":"Hakuna unyonyeshwaji",
        "feeding_practice_breastfeed_option_label":"Je, ananyonyeshwa?",
        "feeding_practice_breastfeed_frequency_label":"Idadi za unyonyeshwaji kwa siku",
        "feeding_practice_mealfeed_option_placeholder":"Hakuna ulishwaji wa chakula",
        "feeding_practice_mealfeed_option_label":"Je, kuna ulishwaji wowote wa chakula?",
        "feeding_practice_mealfeed_value_label":"Chagua chakula kwenye orodha hapa chini",
        "feeding_practice_breastfeed_frequency_placeholder":"0",
        "feeding_practice_mealfeed_value_placeholder":"Hakuna chakula",
        "feeding_practice_breastfeed_empty_option":"Chagua",
        "feeding_practice_mealfeed_empty_option":"Chagua",
        "feeding_practice_breastfeed_save_button":"TUNZA",
        "feeding_practice_mealfeed_save_button":"TUNZA",
        "feeding_practice_breastfeed_cancel_button":"GHAIRI",
        "feeding_practice_mealfeed_cancel_button":"GHAIRI",
        "feeding_practice_breastfeed_no_choice_error_a":"Machaguo yako hayakubaliki!",
        "feeding_practice_breastfeed_no_choice_error_b":"Mtoto lazima anyonye au ale au vyote kwa pamoja",
        "feeding_practice_main_error":"sahihisha makosa hapa chini",
        "feeding_practice_breastfeed_option_error":"Chagua kunyonyesha",
        "feeding_practice_mealfeed_option_error":"Chagua ulishaji wa chakula",
        "feeding_practice_breastfeed_frequency_error":"Chagua idadi za kunyonyesha",
        "feeding_practice_mealfeed_value_error":"Hakuna chakula kilichochaguliwa",
        "feeding_practice_food_info_instruction":"Bonyeza kwenye kila jina la chakula hapa chini ili kutoa maelezo ya namna ulivyomlisha mwanao",
        "feeding_practice_food_info_standard_placeholder":"Hakuna kipimo",
        "feeding_practice_food_info_amount_placeholder":"Hakuna kiasi",
        "feeding_practice_food_info_consistency_placeholder":"Hakuna hali ya chakula",
        "feeding_practice_food_info_quantifier_label":"chagua kipimo cha chakula",
        "feeding_practice_food_info_quantifier_empty_standard":"Chagua kipimo",
        "feeding_practice_food_info_quantifier_empty_amount":"Chagua kiasi",
        "feeding_practice_food_info_quantifier_empty_consistency":"Chagua hali ya chakula",
        "feeding_practice_food_info_no_standard_error":"Chagua kipimo",
        "feeding_practice_food_info_no_amount_error":"Chagua kiasi",
        "feeding_practice_food_info_no_consistency_error":"Chagua hali ya chakula",
        "feeding_practice_food_info_submit_button":"WASILISHA",
        "feeding_practice_food_info_save_button":"TUNZA",
        "feeding_practice_food_info_cancel_button":"GHAIRI",
        "feeding_practice_energy_lebel":"Nishati",
        "feeding_practice_protein_lebel":"Protini",
        "feeding_practice_vitamin_lebel":"Vitamini",
        "feeding_practice_sufficient_nutrients_lebel":"Imekidhi",
        "feeding_practice_insufficient_nutrients_lebel":"Haitoshi/Imezidi",
        "feeding_practice_energy_vs_frequency_success_a":"Hongera!",
        "feeding_practice_energy_vs_frequency_success_b":"Mwanao amelishwa chakula chenye jumla ya nishati",
        "feeding_practice_energy_vs_frequency_success_c":"umri",
        "feeding_practice_energy_vs_frequency_success_d":"Pia, idadi za unyonyeshwaji wa mwanao ni zile zilizo tarajiwa",
        "feeding_practice_energy_vs_frequency_success_e":"Endelea hivi hivi!",
        "feeding_practice_energy_success_a":"amelishwa chakula chenye jumla ya nishati",
        "feeding_practice_energy_success_b":"kama ilivyo tarajiwa kwenye",
        "feeding_practice_energy_success_c":"umri",
        "feeding_practice_protein_success_a":"na protini",
        "feeding_practice_success_bigup_a":"Hongera!",
        "feeding_practice_success_bigup_b":"Endelea hivi hivi!",
        "feeding_practice_frequency_success_a":"Pia",
        "feeding_practice_frequency_success_b_a":"Idadi za unyonyeshwaji wa",
        "feeding_practice_frequency_success_b_b":"ni zile zilizotarajiwa",
        "feeding_practice_energy_warning_a":"amelishwa chakula chenye jumla ya nishati",
        "feeding_practice_energy_warning_b":"Kwa",
        "feeding_practice_energy_warning_c":"umri",
        "feeding_practice_energy_warning_d":"anatarajiwa kulishwa chakula chenye nishati",
        "feeding_practice_energy_warning_e":"kwa siku",
        "feeding_practice_protein_warning_a":"na protini",
        "feeding_practice_frequency_warning_a_a":"Idadi za kunyonyeshwa",
        "feeding_practice_frequency_warning_a_b":"ziko chini ya matarajio.",
        "feeding_practice_frequency_warning_b":"Hakikisha",
        "feeding_practice_frequency_warning_c":"ananyonyeshwa angalau mara 8 kwa siku",
        "feeding_practice_frequency_warning_c_5":"ananyonyeshwa angalau mara 5 kwa siku",
        "feeding_practice_warning_unbigup_a":"Lishe isiyotarajiwa!",
        "feeding_practice_warning_unbigup_b_a":"Badilisha",
        "feeding_practice_warning_unbigup_b_b":"utaratibu wa ulishaji!",
        "feeding_practice_bteastfeed_only_warning_a":"Kutokana na",
        "feeding_practice_bteastfeed_only_warning_b":"umri",
        "feeding_practice_bteastfeed_only_warning_c":"anatarajiwa kunyonya angalau mara 8 kwa siku",
        "feeding_practice_mealfeed_also_warning_a":"Kwa",
        "feeding_practice_mealfeed_also_warning_b":"umri",
        "feeding_practice_mealfeed_also_warning_c":"anatarajiwa kulishwa chakula chenye jumla ya nishati",
        "feeding_practice_mealfeed_also_warning_d":"kwa siku",
        "feeding_practice_mealfeed_also_warning_e":"Tafadhali mpe",
        "feeding_practice_mealfeed_also_warning_f":"chakula",
        "feeding_practice_mealfeed_also_warning_g":"Pia,",
        "feeding_practice_energy_deficiency_message_a":"ana upungufu wa nishati ya",
        "feeding_practice_energy_deficiency_message_b":"Tafadhali ongeza moja ya muunganiko wa vyakula hapa chini ili kufidia upungufu huu wa nishati",
        "feeding_practice_energy_deficiency_message_c":"Jumla ya nishati",
        "feeding_practice_protein_deficiency_message_a":"na upungufu wa protini",
        "feeding_practice_protein_deficiency_message_b":"pamoja na protini",
        "feeding_practice_protein_deficiency_message_c":"Jumla ya protini",
        "growth_chart_no_progress_data":"Hakuna taarifa za maendeleo ya mtoto huyu zilizorekodiwa",
        "growth_chart_weight_title":"CHATI YA UKUAJI (Umri dhidi ya Uzito)",
        "growth_chart_height_title":"CHATI YA UKUAJI (Umri dhidi ya Urefu)",
        "growth_chart_x_axis":"Umri (mwezi)",
        "growth_chart_y_axis_weight":"Uzito",
        "growth_chart_y_axis_height":"Urefu",
        "normal_status":"Nzuri",
        "mild_status":"Hafifu",
        "severe_status":"Mbaya",
        "progress_status":"Ukuaji",
        "feeding_advice_title":"Bonyeza kwenye tarehe yenye kivuli kuangalia ushauri uliopita",
        "feeding_advice_no_suggestion":"Hakuna mapendekezo yaliyorekodiwa kwa mwanao",
        "feeding_advice_no_advice":"Hakuna ushauri wa lishe uliorekodiwa kwenye hii tarehe!",
        "feeding_advice_weight_height_title":"UZITO DHIDI YA UREFU",
        "feeding_advice_sub_title":"USHAURI WA LISHE",
        "hw_home_home_label":"Mwanzo",
        "hw_home_add_child_label":"Sajili mtoto",
        "hw_home_add_hw_label":"Sajili mhudumu afya",
        "hw_home_view_hw_label":"Angalia wahudumu afya",
        "hw_home_children_table_title":"Taarifa za watoto",
        "hw_home_children_table_fullname":"Jina kamili",
        "hw_home_children_table_sex":"Jinsia",
        "hw_home_children_table_currentweight":"Uzito wa sasa",
        "hw_home_children_table_currentheight":"Urefu wa sasa",
        "hw_home_children_table_more":"Zaidi",
        "hw_home_basicinfo_label":"Taarifa muhimu",
        "hw_home_changepassword_label":"Badili neno siri",
        "hw_home_logout_label":"Toka",
        "hw_child_register_form_title":"USAJILI WA MTOTO",
        "hw_child_register_form_childname":"Jina",
        "hw_child_register_form_childname":"Jina",
        "hw_child_register_form_childname_fname":"Jina la kwanza",
        "hw_child_register_form_childname_lname":"Jina la ukoo",
        "hw_child_register_form_childname_mname":"Jina la kati",
        "hw_child_register_form_sex":"Jinsia",
        "hw_child_register_form_sex_male":"Kiume",
        "hw_child_register_form_sex_female":"Kike",
        "hw_child_register_form_birthinfo":"Tarehe ya kuzaliwa",
        "hw_child_register_form_birthinfo_birthplace":"Mahali pa kuzaliwa",
        "hw_child_register_form_birthinfo_weightatbirth":"Uzito wa kuzaliwa",
        "hw_child_register_form_currentmetrics":"Vipimo vya sasa",
        "hw_child_register_form_currentmetrics_currentweight":"Uzito wa sasa",
        "hw_child_register_form_currentmetrics_currentheight":"Urefu wa sasa",
        "hw_child_register_form_siblinginfo":"Taarifa za ndugu",
        "hw_child_register_form_siblinginfo_twinsibling":"Pacha",
        "hw_child_register_form_siblinginfo_underweightsibling":"Ndugu mwenye uzito mdogo",
        "hw_child_register_form_basicinfo":"Taarifa muhimu",
        "hw_child_register_form_basicinfo_settlement":"Makazi ya sasa",
        "hw_child_register_form_basicinfo_caregiver":"Muangalizi wa mtoto",
        "hw_child_register_form_basicinfo_caregiver_mother":"Mama",
        "hw_child_register_form_basicinfo_caregiver_father":"Baba",
        "hw_child_register_form_basicinfo_caregiver_guardian":"Mlezi",
        "hw_child_register_form_challengesatbirth":"Tatizo lolote wakati wa kuzaliwa",
        "hw_child_register_form_challengesatbirth_anychallenge":"Chagua",
        "hw_child_register_form_challengesatbirth_medicalchallenge":"Tatizo gani?",
        "hw_child_register_form_next_button":"Endelea",
        "hw_mother_register_form_title":"USAJILI WA MWANAGALIZI",
        "hw_mother_register_form_name":"Jina",
        "hw_mother_register_form_name_fname":"Jina la kwanza",
        "hw_mother_register_form_name_lname":"Jina la ukoo",
        "hw_mother_register_form_contact":"Mawasiliano",
        "hw_mother_register_form_contact_phone":"Namba ya simu",
        "hw_mother_register_form_contact_email":"Barua pepe",
        "hw_mother_register_form_birthinfo":"Tarehe ya kuzaliwa",
        "hw_mother_register_form_birthinfo_dob":"Tarehe ya kuzaliwa",
        "hw_mother_register_form_birthinfo_birthplace":"Mahali pa kuzaliwa",
        "hw_mother_register_form_childreninfo":"Taarifa za watoto",
        "hw_mother_register_form_childreninfo_childrennumber":"Idadi ya watoto",
        "hw_mother_register_form_childreninfo_alivechildren":"Watoto walio hai",
        "hw_mother_register_form_anymedicalneeds":"Tatizo lolote wakati wa kujifungua",
        "hw_mother_register_form_medicalneeds":"Tatizo gani?",
        "hw_empty_option":"Chagua",
        "hw_mother_register_form_submit_button":"Sajili",
        "hw_healthworker_register_form_title":"USAJILI WA MHUDUMU AFYA",
        "hw_healthworker_register_form_name":"Jina kamili",
        "hw_healthworker_register_form_name_fname":"Jina la kwanza",
        "hw_healthworker_register_form_name_lname":"Jina la ukoo",
        "hw_healthworker_register_form_basicinfo":"Taarifa muhimu",
        "hw_healthworker_register_form_basicinfo_phone":"Namba ya simu",
        "hw_healthworker_register_form_basicinfo_email":"Barua pepe",
        "hw_healthworker_register_form_basicinfo_position":"Cheo/Nafasi",
        "hw_healthworker_register_form_accountsetting":"Taarifa za akaunti",
        "hw_healthworker_register_form_accountsetting_username":"Username",
        "hw_healthworker_register_form_accountsetting_password":"Nenosiri",
        "hw_healthworker_register_form_accountsetting_repassword":"Thibitisha nenosiri",
        "hw_healthworker_register_form_submit_button":"Sajili",
        "hw_healthworker_table_fname":"Jina la kwanza",
        "hw_healthworker_table_lname":"Jina la ukoo",
        "hw_healthworker_table_phone":"Namba ya simu",
        "hw_healthworker_table_email":"Barua pepe",
        "hw_healthworker_table_position":"Cheo/Nafasi",
        "hw_healthworker_table_activate":"Huisha",
        "hw_healthworker_table_deactivate":"Fisha",
        "hw_healthworker_table_view":"Angalia",
        "hw_healthworker_view_form_title":"TAARIFA MUHIMU",
        "hw_healthworker_view_form_edit_button":"BADILI",
        "hw_healthworker_view_form_save_button":"TUNZA"
    },
    "en": {
        "language":"english",
        "yes_option":"Yes",
        "no_option":"No",
        "male_sex":"Male",
        "female_sex":"Female",
        "male_subject_pronoun":"he",
        "male_personal_pronoun":"him",
        "male_possessive_pronoun":"his",
        "female_subject_pronoun":"she",
        "passwords_unmatch":"Passwords did not match",
        "incorrect_old_password":"Incorrect Old Password",
        "password_change_success":"Password was Successful Changed",
        "female_personal_pronoun":"her",
        "female_possessive_pronoun":"her",
        "login_title":"SMART GROWTH DIARY",
        "login_button":"LOG IN","page":"login",
        "login_username_label":"Enter Username",
        "login_password_label":"Enter Password",
        "forgot_password_button":"Forgot password",
        "login_error":"Invalid login",
        "dashboard_title":"SMARTGROWTHDIARY",
        "dashboard_metrics_button":"METRICS",
        "dashboard_growth_chart_button":"GROWTH CHART",
        "dashboard_nutritional_advice_button":"NUTRITIONAL ADVICE",
        "dashboard_feeding_advice_button":"SMART FEEDING",
        "dashboard_contact_us_button":"CONTACT US",
        "dashboard_faqs_button":"FAQS",
        "dashboard_home_button":"Dashboard",
        "dashboard_chart_button":"Chart",
        "dashboard_contact_button":"Contact",
        "dashboard_advice_button":"Advices",
        "dashboard_short_faqs_button":"FAQS",
        "dashboard_child_name_label":"NAME",
        "dashboard_child_age_label":"AGE",
        "dashboard_child_dob_label":"DOB",
        "dashboard_child_sex_label":"SEX",
        "dashboard_child_residence_label":"RESIDENCE",
        "dashboard_child_twin_sibling_status_label":"TWIN SIBLING?",
        "dashboard_change_password_label":"CHANGE PASSWORD",
        "dashboard_logout_label":"LOGOUT",
        "metrics_weight_label":"Enter Weight",
        "metrics_height_label":"Enter Height",
        "metrics_submit_button":"CALCULATE",
        "metrics_form_title":"Enter details below to know the progress of",
        "metrics_success_a":"Congratulation!",
        "metrics_success_ax":"The weight of",
        "metrics_success_b":"is growing well",
        "metrics_success_bx":"is still good<br/> But the weight is decreesing compared to the last recorded one",
        "metrics_weight_error":"Child weight must not exceed 30kg",
        "metrics_height_error":"Make sure that the height is not less than 45 and the decimal point for the height is 5 or 0",
        "metrics_age_error_a":"can no longer add metrics data because",
        "metrics_age_error_b":"age is over 24 months",
        "metrics_warning_title":"We have found the following challenge(s) for",
        "metrics_warning_footer":"Click next for nutritional advice",
        "metrics_warning_save_button":"SAVE",
        "metrics_warning_next_button":"NEXT",
        "metrics_warning_cancel_button":"CANCEL",
        "metrics_warning_WA_label":"W/A",
        "metrics_warning_HA_label":"H/A",
        "metrics_warning_WH_label":"W/H",
        "metrics_warning_is_sick_question_a":"Is",
        "metrics_warning_is_sick_question_b":"sick",
        "metrics_warning_empty_option":"Which disease?",
        "metrics_warning_illness_warning_a":"Due to illness of",
        "metrics_warning_illness_warning_b":"please see a doctor immediately",
        "metrics_warning_illness_warning_instruction_a":"Click NEXT to get nutritional status of",
        "metrics_warning_illness_warning_instruction_b":"or click CANCEL to go back to dashboard",
        "metrics_warning_severe_under_WA_status":"Severe Underweight",
        "metrics_warning_moderate_under_WA_status":"Moderate Underweight",
        "metrics_warning_mild_under_WA_status":"Mild Underweight",
        "metrics_warning_severe_over_WA_status":"Severe Overweight",
        "metrics_warning_moderate_over_WA_status":"Moderate Overweight",
        "metrics_warning_mild_over_WA_status":"Mild Overweight",
        "metrics_warning_severe_under_HA_status":"Severe Stunting",
        "metrics_warning_moderate_under_HA_status":"Moderate Stunting",
        "metrics_warning_mild_under_HA_status":"Mild Stunted",
        "metrics_warning_severe_over_HA_status":"Maybe Abnormal",
        "metrics_warning_moderate_over_HA_status":"Normal Height",
        "metrics_warning_mild_over_HA_status":"Normal Height",
        "metrics_warning_severe_under_WH_status":"Severe Wasting",
        "metrics_warning_moderate_under_WH_status":"Moderate Wasting",
        "metrics_warning_mild_under_WH_status":"Mild Wasting",
        "metrics_warning_severe_over_WH_status":"Obese",
        "metrics_warning_moderate_over_WH_status":"Overweight",
        "metrics_warning_mild_over_WH_status":"Overweight",
        "feeding_practice_instruction_a":"click on",
        "feeding_practice_instruction_b":"to add your breastfeeding and complementary feeding option",
        "feeding_practice_next_button":"NEXT",
        "feeding_practice_submit_button":"Submit data",
        "feeding_practice_breastfeed_label":"ENTER BREASTFEEDING INFO",
        "feeding_practice_mealfeed_label":"ADD COMPLEMENTARY FEEDING WITHIN 24 HRS",
        "feeding_practice_breastfeed_option_placeholder":"No breast feeding",
        "feeding_practice_breastfeed_option_label":"Breastfeeding?",
        "feeding_practice_breastfeed_frequency_label":"Breastfeeding Frequency per Day",
        "feeding_practice_mealfeed_option_placeholder":"No complementary feeding",
        "feeding_practice_mealfeed_option_label":"Any Complementary Feeding?",
        "feeding_practice_mealfeed_value_label":"select food from the list below",
        "feeding_practice_breastfeed_frequency_placeholder":"0 frequency",
        "feeding_practice_mealfeed_value_placeholder":"No food",
        "feeding_practice_breastfeed_empty_option":"select",
        "feeding_practice_mealfeed_empty_option":"select",
        "feeding_practice_breastfeed_save_button":"SAVE",
        "feeding_practice_mealfeed_save_button":"SAVE",
        "feeding_practice_breastfeed_cancel_button":"CANCEL",
        "feeding_practice_mealfeed_cancel_button":"CANCEL",
        "feeding_practice_breastfeed_no_choice_error_a":"Your choices are not acceptable!",
        "feeding_practice_breastfeed_no_choice_error_b":"Child must be breast feed or complementary feed or both",
        "feeding_practice_main_error":"Correct error(s) bellow",
        "feeding_practice_breastfeed_option_error":"Select breast feeding option",
        "feeding_practice_mealfeed_option_error":"Select meal feeding option",
        "feeding_practice_breastfeed_frequency_error":"Select breast frequency",
        "feeding_practice_mealfeed_value_error":"No food selected",
        "feeding_practice_food_info_instruction":"Click on each food item below to provide more details about what your child ate",
        "feeding_practice_food_info_standard_placeholder":"No standard",
        "feeding_practice_food_info_amount_placeholder":"No amount",
        "feeding_practice_food_info_consistency_placeholder":"No consistency",
        "feeding_practice_food_info_quantifier_label":"select food quantifier",
        "feeding_practice_food_info_quantifier_empty_standard":"Select standard",
        "feeding_practice_food_info_quantifier_empty_amount":"Select amount",
        "feeding_practice_food_info_quantifier_empty_consistency":"Select consistency",
        "feeding_practice_food_info_no_standard_error":"Select standard",
        "feeding_practice_food_info_no_amount_error":"Select amount",
        "feeding_practice_food_info_no_consistency_error":"Select consistency",
        "feeding_practice_food_info_submit_button":"SUBMIT",
        "feeding_practice_food_info_save_button":"SAVE",
        "feeding_practice_food_info_cancel_button":"CANCEL",
        "feeding_practice_energy_lebel":"Energy",
        "feeding_practice_protein_lebel":"Protein",
        "feeding_practice_vitamin_lebel":"Vitamin",
        "feeding_practice_sufficient_nutrients_lebel":"Sufficient",
        "feeding_practice_insufficient_nutrients_lebel":"Not enough/Exceeded",
        "feeding_practice_energy_vs_frequency_success_a":"Congratulation!",
        "feeding_practice_energy_vs_frequency_success_b":"Your child has been fed food of total energy",
        "feeding_practice_energy_vs_frequency_success_c":"age",
        "feeding_practice_energy_vs_frequency_success_d":"Also,Your child breastfed frequency is what expected",
        "feeding_practice_energy_vs_frequency_success_e":"Keep going like this!",
        "feeding_practice_energy_success_a":"Your child has been fed food of total energy",
        "feeding_practice_energy_success_b":"as is expected at",
        "feeding_practice_energy_success_c":"age",
        "feeding_practice_protein_success_a":"and protein",
        "feeding_practice_success_bigup_a":"Congratulation!",
        "feeding_practice_success_bigup_b":"Keep going like this!",
        "feeding_practice_frequency_success_a":"Also",
        "feeding_practice_frequency_success_b_a":"breastfeeding frequency of",
        "feeding_practice_frequency_success_b_b":"is what expected",
        "feeding_practice_energy_warning_a":"has been fed food of total energy",
        "feeding_practice_energy_warning_b":"At",
        "feeding_practice_energy_warning_c":"age",
        "feeding_practice_energy_warning_d":"is expected to be fed food of total energy",
        "feeding_practice_energy_warning_e":"per day",
        "feeding_practice_protein_warning_a":"and protein",
        "feeding_practice_frequency_warning_a_a":"breastfeeding frequency of",
        "feeding_practice_frequency_warning_a_b":"is below expected",
        "feeding_practice_frequency_warning_b":"Make sure",
        "feeding_practice_frequency_warning_c":"is breastfed atleast 8 times per day",
        "feeding_practice_frequency_warning_c_5":"is breastfed atleast 5 times per day",
        "feeding_practice_warning_unbigup_a":"Unexpected Nutrition!",
        "feeding_practice_warning_unbigup_b_a":"Change",
        "feeding_practice_warning_unbigup_b_b":"feeding pattern!",
        "feeding_practice_bteastfeed_only_warning_a":"Due to",
        "feeding_practice_bteastfeed_only_warning_b":"age",
        "feeding_practice_bteastfeed_only_warning_c":"is expected to breastfed atleast 8 times per day",
        "feeding_practice_mealfeed_also_warning_a":"At",
        "feeding_practice_mealfeed_also_warning_b":"age",
        "feeding_practice_mealfeed_also_warning_c":"is expected to be fed food of total energy",
        "feeding_practice_mealfeed_also_warning_d":"per day",
        "feeding_practice_mealfeed_also_warning_e":"Please, Give",
        "feeding_practice_mealfeed_also_warning_f":"food",
        "feeding_practice_mealfeed_also_warning_g":"Also,",
        "feeding_practice_energy_deficiency_message_a":"has energy deficiency of",
        "feeding_practice_energy_deficiency_message_b":"Please add the one of the following food commbinations to compasate this energy deficiency",
        "feeding_practice_energy_deficiency_message_c":"Total energy",
        "feeding_practice_protein_deficiency_message_a":"and protein deficiency",
        "feeding_practice_protein_deficiency_message_b":"with protein",
        "feeding_practice_protein_deficiency_message_c":"Total protein",
        "growth_chart_no_progress_data":"No progress data recorded for this child",
        "growth_chart_weight_title":"GROWTH CHART (Age vs weight)",
        "growth_chart_height_title":"GROWTH CHART (Age vs height)",
        "growth_chart_x_axis":"Time(month)",
        "growth_chart_y_axis_weight":"Weight",
        "growth_chart_y_axis_height":"Height",
        "progress_status":"Progress",
        "normal_status":"Normal",
        "mild_status":"Mild",
        "severe_status":"Severe",
        "feeding_advice_title":"Click on the highlighted date to view previous advice",
        "feeding_advice_no_suggestion":"No suggestions recorded for this child",
        "feeding_advice_no_advice":"No Feeding Advice has been recorded at this date!",
        "feeding_advice_weight_height_title":"WEIGHT VS HEIGHT",
        "feeding_advice_sub_title":"FEEDING ADVICE",
        "hw_home_home_label":"Home",
        "hw_home_add_child_label":"Add new child",
        "hw_home_add_hw_label":"Add healthworker",
        "hw_home_view_hw_label":"View healthworkers",
        "hw_home_children_table_title":"Children informations",
        "hw_home_children_table_fullname":"Full name",
        "hw_home_children_table_sex":"Sex",
        "hw_home_children_table_currentweight":"Current weight",
        "hw_home_children_table_currentheight":"Current height",
        "hw_home_children_table_more":"More",
        "hw_home_basicinfo_label":"Basic information",
        "hw_home_changepassword_label":"Change password",
        "hw_home_logout_label":"Logout",
        "hw_child_register_form_title":"CHILD REGISTRATION",
        "hw_child_register_form_childname":"Name",
        "hw_child_register_form_childname_fname":"First name",
        "hw_child_register_form_childname_lname":"Last name",
        "hw_child_register_form_childname_mname":"Middle name",
        "hw_child_register_form_sex":"Sex",
        "hw_child_register_form_sex_male":"Male",
        "hw_child_register_form_sex_female":"Female",
        "hw_child_register_form_birthinfo":"Birth information",
        "hw_child_register_form_birthinfo_birthplace":"Birth place",
        "hw_child_register_form_birthinfo_weightatbirth":"Weight at birth",
        "hw_child_register_form_currentmetrics":"Current Metrics",
        "hw_child_register_form_currentmetrics_currentweight":"Current weight",
        "hw_child_register_form_currentmetrics_currentheight":"Current height",
        "hw_child_register_form_siblinginfo":"Sibling Information",
        "hw_child_register_form_siblinginfo_twinsibling":"Twin sibling",
        "hw_child_register_form_siblinginfo_underweightsibling":"Underweight Sibling",
        "hw_child_register_form_basicinfo":"Basic Information",
        "hw_child_register_form_basicinfo_settlement":"Settlement",
        "hw_child_register_form_basicinfo_caregiver":"Caregiver",
        "hw_child_register_form_basicinfo_caregiver_mother":"Mother",
        "hw_child_register_form_basicinfo_caregiver_father":"Father",
        "hw_child_register_form_basicinfo_caregiver_guardian":"Guardian",
        "hw_child_register_form_challengesatbirth":"Challenges at birth",
        "hw_child_register_form_challengesatbirth_anychallenge":"Any challenge at birth",
        "hw_child_register_form_challengesatbirth_medicalchallenge":"Medical challenge",
        "hw_child_register_form_next_button":"Next",
        "hw_mother_register_form_title":"CAREGIVER REGISTRATION",
        "hw_mother_register_form_name":"Name",
        "hw_mother_register_form_name_fname":"First name",
        "hw_mother_register_form_name_lname":"Last name",
        "hw_mother_register_form_contact":"Contact",
        "hw_mother_register_form_contact_phone":"Phone number",
        "hw_mother_register_form_contact_email":"Email",
        "hw_mother_register_form_birthinfo":"Birth Information",
        "hw_mother_register_form_birthinfo_dob":"Birth date",
        "hw_mother_register_form_birthinfo_birthplace":"Birth place",
        "hw_mother_register_form_childreninfo":"Children Information",
        "hw_mother_register_form_childreninfo_childrennumber":"Children number",
        "hw_mother_register_form_childreninfo_alivechildren":"Alive children",
        "hw_mother_register_form_anymedicalneeds":"Any medical needs",
        "hw_mother_register_form_medicalneeds":"Medical needs",
        "hw_empty_option":"Select",
        "hw_mother_register_form_submit_button":"Register",
        "hw_healthworker_register_form_title":"HEALTHWORKER REGISTRATION",
        "hw_healthworker_register_form_name":"Full name",
        "hw_healthworker_register_form_name_fname":"First name",
        "hw_healthworker_register_form_name_lname":"Last name",
        "hw_healthworker_register_form_basicinfo":"Basic information",
        "hw_healthworker_register_form_basicinfo_phone":"Phone number",
        "hw_healthworker_register_form_basicinfo_email":"Email",
        "hw_healthworker_register_form_basicinfo_position":"Position",
        "hw_healthworker_register_form_accountsetting":"Account Setting",
        "hw_healthworker_register_form_accountsetting_username":"Username",
        "hw_healthworker_register_form_accountsetting_password":"Password",
        "hw_healthworker_register_form_accountsetting_repassword":"Confirm password",
        "hw_healthworker_register_form_submit_button":"Register",
        "hw_healthworker_table_fname":"First name",
        "hw_healthworker_table_lname":"Last name",
        "hw_healthworker_table_phone":"Phone",
        "hw_healthworker_table_email":"Email",
        "hw_healthworker_table_position":"Position",
        "hw_healthworker_table_activate":"Activate",
        "hw_healthworker_table_deactivate":"Dectivate",
        "hw_healthworker_table_view":"View",
        "hw_healthworker_view_form_title":"BASIC INFO",
        "hw_healthworker_view_form_edit_button":"EDIT",
        "hw_healthworker_view_form_save_button":"SAVE"
    }
}